<template>
	<div>
		<import import-url="/api/customers/import" template-url="/customers/import-template" file-name="customers_file"></import>
	</div>
</template>

<script>
	import Import from "@components/partials/Import";

	export default {
		components: {
			Import
		},
	};
</script>
